/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The McMcTranslationParam model module.
 * @module model/McMcTranslationParam
 * @version 1.0
 */
class McMcTranslationParam {
    /**
     * Constructs a new <code>McMcTranslationParam</code>.
     * @alias module:model/McMcTranslationParam
     */
    constructor() { 
        
        McMcTranslationParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>McMcTranslationParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/McMcTranslationParam} obj Optional instance to populate.
     * @return {module:model/McMcTranslationParam} The populated <code>McMcTranslationParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new McMcTranslationParam();

            if (data.hasOwnProperty('explanation')) {
                obj['explanation'] = ApiClient.convertToType(data['explanation'], 'String');
            }
            if (data.hasOwnProperty('question')) {
                obj['question'] = ApiClient.convertToType(data['question'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} explanation
 */
McMcTranslationParam.prototype['explanation'] = undefined;

/**
 * @member {String} question
 */
McMcTranslationParam.prototype['question'] = undefined;






export default McMcTranslationParam;

